import { getScaleImageSrc } from 'wix-rich-content-common/libs/imageUtils';
import { Node_Type } from 'ricos-types';
import React, { PureComponent, useContext, Component } from 'react';
import { withEditorEvents } from 'wix-rich-content-editor-common/libs/EditorEventsContext';
import cls from 'classnames';
import FlipMove from 'react-flip-move';
import Measure, { withContentRect } from 'react-measure';
import PropTypes from 'prop-types';
import { cloneDeep, clamp } from 'lodash';
import ReactModal from 'react-modal';
import InfiniteScroll from 'react-infinite-scroller';
import { Image } from 'wix-rich-content-ui-components';
import { RicosContext, withRicosContext, withZIndexContext, RicosViewerContext } from 'ricos-context';
import Tooltip from 'wix-rich-content-common/libs/Tooltip';

function getRandomValue(pool) {
  return pool[Math.floor(Math.random() * pool.length)];
}
function toBackgroundString(background, backgroundType, width, height) {
  var _a, _b;
  switch (backgroundType) {
    case BACKGROUND_TYPES.GRADIENT:
      try {
        const { gradient } = background;
        return `linear-gradient(${gradient.angle}deg, ${gradient.startColor}, ${gradient.lastColor})`;
      } catch (error) {
        console.error(error);
        return background;
      }
    case BACKGROUND_TYPES.IMAGE:
      if (!width || !height) {
        return null;
      }
      const URL = (_b = (_a = background.image) == null ? void 0 : _a.src) == null ? void 0 : _b.url;
      const imageSrc = getScaleImageSrc(URL, width, height);
      return `url('${imageSrc}') center / cover`;
    case BACKGROUND_TYPES.COLOR:
    default:
      return background.color;
  }
}

const LAYOUTS = {
  LIST: "LIST",
  GRID: "GRID"
};
var BACKGROUND_TYPES = /* @__PURE__ */ ((BACKGROUND_TYPES2) => {
  BACKGROUND_TYPES2["COLOR"] = "COLOR";
  BACKGROUND_TYPES2["IMAGE"] = "IMAGE";
  BACKGROUND_TYPES2["GRADIENT"] = "GRADIENT";
  return BACKGROUND_TYPES2;
})(BACKGROUND_TYPES || {});
const BACKGROUND_PRESETS = {
  ["COLOR" /* COLOR */]: [
    "#EF4538",
    "#F96132",
    "#FAAD4D",
    "#31B778",
    "#488FFE",
    "#11428D",
    "#6C49EF",
    "#8C0F7A"
  ],
  ["IMAGE" /* IMAGE */]: [
    "https://static.wixstatic.com/media/2dfdd3_03c2331b19bb41108b34938edf8951dd~mv2.jpg",
    "https://static.wixstatic.com/media/2dfdd3_df028f9258cf4fe0a1b7f75a3916def1~mv2.jpg",
    "https://static.wixstatic.com/media/2dfdd3_b120b7d9cffd4645bb143beadef13c56~mv2.jpg",
    "https://static.wixstatic.com/media/2dfdd3_1977932e94064f168abaaa2c04b678a5~mv2.jpg",
    "https://static.wixstatic.com/media/2dfdd3_17b428ae1fb14736a2ab30994620ee62~mv2.jpg",
    "https://static.wixstatic.com/media/2dfdd3_934a080451cd4b3eb6e7c9485a07972c~mv2.jpg",
    "https://static.wixstatic.com/media/2dfdd3_0b440a1138ba4c99bc954eb4d06ec0ad~mv2.jpg",
    "https://static.wixstatic.com/media/2dfdd3_395a5522e3474b3ca34194633e90ea81~mv2.jpg"
  ],
  ["GRADIENT" /* GRADIENT */]: [
    {
      angle: 45,
      startColor: "#EF4538",
      lastColor: "#488FFE"
    },
    {
      angle: 45,
      startColor: "#F96132",
      lastColor: "#FAAD4D"
    },
    {
      angle: 45,
      startColor: "#31B778",
      lastColor: "#FAAD4D"
    },
    {
      angle: 45,
      startColor: "#0D6546",
      lastColor: "#31B778"
    },
    {
      angle: 45,
      startColor: "#488FFE",
      lastColor: "#8C0F7A"
    },
    {
      angle: 45,
      startColor: "#11428D",
      lastColor: "#488FFE"
    },
    {
      angle: 45,
      startColor: "#6C49EF",
      lastColor: "#31B778"
    },
    {
      angle: 45,
      startColor: "#8C0F7A",
      lastColor: "#FAAD4D"
    }
  ].map((value) => JSON.stringify(value))
};
const OPTION_IMAGES_POOL = [
  "https://static.wixstatic.com/media/fb62d9f8e7824b2e90b13b971e700b92.jpg",
  "https://static.wixstatic.com/media/3a27828e768344158489df4f2c03cfb2.jpg"
];
const POLL_IMAGES_POOL = [
  "https://static.wixstatic.com/media/436483e6ed9e41fe91b9f286d2ea4efb.jpg"
];
const MEMBER_ROLES = {
  ALL: "ALL",
  SITE_MEMBERS: "SITE_MEMBERS"
};
const DIRECTION = {
  LTR: "ltr",
  RTL: "rtl"
};
const VISIBILITY_OPTIONS = {
  EVERYONE: "EVERYONE",
  VOTERS: "VOTERS",
  CREATOR: "CREATOR"
};
const DEFAULT_RICOS_COMPONENT_DATA = {
  containerData: {
    width: {
      size: "CONTENT"
    },
    alignment: "CENTER",
    textWrap: true
  },
  poll: {
    ownVotes: [],
    title: "",
    settings: {
      permissions: {
        view: VISIBILITY_OPTIONS.VOTERS,
        vote: MEMBER_ROLES.ALL,
        allowMultipleVotes: false
      },
      showVoters: true,
      showVotesCount: true
    },
    options: []
  },
  layout: {
    poll: {
      type: LAYOUTS.LIST,
      direction: DIRECTION.LTR.toUpperCase(),
      enableImage: true
    },
    options: {
      enableImage: false
    }
  },
  design: {
    poll: {
      background: {
        type: "IMAGE" /* IMAGE */,
        image: { src: { url: getRandomValue(BACKGROUND_PRESETS["IMAGE" /* IMAGE */]) } }
      },
      borderRadius: 0
    },
    options: {
      borderRadius: 0
    }
  }
};

const POLL_TYPE = "wix-draft-plugin-poll";

var __defProp$n = Object.defineProperty;
var __getOwnPropSymbols$j = Object.getOwnPropertySymbols;
var __hasOwnProp$j = Object.prototype.hasOwnProperty;
var __propIsEnum$j = Object.prototype.propertyIsEnumerable;
var __defNormalProp$n = (obj, key, value) => key in obj ? __defProp$n(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$j = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$j.call(b, prop))
      __defNormalProp$n(a, prop, b[prop]);
  if (__getOwnPropSymbols$j)
    for (var prop of __getOwnPropSymbols$j(b)) {
      if (__propIsEnum$j.call(b, prop))
        __defNormalProp$n(a, prop, b[prop]);
    }
  return a;
};
const RemoveIcon = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues$j({ width: "24", height: "24", viewBox: "0 0 24 24" }, props), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.23 7l.77.77L12.769 12 17 16.23l-.77.77L12 12.769 7.77 17 7 16.23 11.23 12 7 7.77 7.77 7 12 11.231 16.23 7z"
  }
));

var __defProp$m = Object.defineProperty;
var __getOwnPropSymbols$i = Object.getOwnPropertySymbols;
var __hasOwnProp$i = Object.prototype.hasOwnProperty;
var __propIsEnum$i = Object.prototype.propertyIsEnumerable;
var __defNormalProp$m = (obj, key, value) => key in obj ? __defProp$m(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$i = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$i.call(b, prop))
      __defNormalProp$m(a, prop, b[prop]);
  if (__getOwnPropSymbols$i)
    for (var prop of __getOwnPropSymbols$i(b)) {
      if (__propIsEnum$i.call(b, prop))
        __defNormalProp$m(a, prop, b[prop]);
    }
  return a;
};
const CheckIcon = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues$i({ width: "24px", height: "24px", viewBox: "0 0 24 24" }, props), /* @__PURE__ */ React.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React.createElement("g", { transform: "translate(-496.000000, 0.000000)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement(
  "polyline",
  {
    stroke: "#FFFFFF",
    strokeWidth: "2",
    points: "508 23.8193359 508 64 0 64 0 12 496.790039 12"
  }
), /* @__PURE__ */ React.createElement("g", { transform: "translate(496.000000, 0.000000)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("circle", { fill: "#FFFFFF", cx: "12", cy: "12", r: "12" }), /* @__PURE__ */ React.createElement("g", { transform: "translate(5.000000, 8.000000)", fill: "currentColor" }, /* @__PURE__ */ React.createElement("polygon", { points: "12.2335029 0.239154296 13.4174702 1.3883133 5.59026761 9.73257326 0.586372643 5.73025155 1.59665912 4.42329121 5.43146554 7.49052765" }))), /* @__PURE__ */ React.createElement("g", { transform: "translate(5.000000, 8.000000)" }))))));

var __defProp$l = Object.defineProperty;
var __getOwnPropSymbols$h = Object.getOwnPropertySymbols;
var __hasOwnProp$h = Object.prototype.hasOwnProperty;
var __propIsEnum$h = Object.prototype.propertyIsEnumerable;
var __defNormalProp$l = (obj, key, value) => key in obj ? __defProp$l(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$h = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$h.call(b, prop))
      __defNormalProp$l(a, prop, b[prop]);
  if (__getOwnPropSymbols$h)
    for (var prop of __getOwnPropSymbols$h(b)) {
      if (__propIsEnum$h.call(b, prop))
        __defNormalProp$l(a, prop, b[prop]);
    }
  return a;
};
const AddIcon = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues$h({ width: "72", height: "72", viewBox: "0 0 72 72" }, props), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M38.4 12v21.6H60v4.8H38.4V60h-4.8V38.4H12v-4.8h21.6V12h4.8z"
  }
));

var __defProp$k = Object.defineProperty;
var __getOwnPropSymbols$g = Object.getOwnPropertySymbols;
var __hasOwnProp$g = Object.prototype.hasOwnProperty;
var __propIsEnum$g = Object.prototype.propertyIsEnumerable;
var __defNormalProp$k = (obj, key, value) => key in obj ? __defProp$k(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$g = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$g.call(b, prop))
      __defNormalProp$k(a, prop, b[prop]);
  if (__getOwnPropSymbols$g)
    for (var prop of __getOwnPropSymbols$g(b)) {
      if (__propIsEnum$g.call(b, prop))
        __defNormalProp$k(a, prop, b[prop]);
    }
  return a;
};
const LoaderIcon = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues$g({ width: "24", height: "24", viewBox: "0 0 24 24" }, props), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement(
  "path",
  {
    id: "file-upload-loader-icon-path",
    d: "M14.064 5.948l1.518-.507A8 8 0 1 1 10.473.39l-.506 1.519a6.4 6.4 0 1 0 4.097 4.04z"
  }
)), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", transform: "translate(4 4)" }, /* @__PURE__ */ React.createElement("mask", { id: "file-upload-loader-mask", fill: "#fff" }, /* @__PURE__ */ React.createElement("use", { xlinkHref: "#file-upload-loader-icon-path" })), /* @__PURE__ */ React.createElement("use", { fill: "currentColor", xlinkHref: "#file-upload-loader-icon-path" }), /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M-4-4h24v24H-4z", mask: "url(#file-upload-loader-mask)" })));

var __defProp$j = Object.defineProperty;
var __getOwnPropSymbols$f = Object.getOwnPropertySymbols;
var __hasOwnProp$f = Object.prototype.hasOwnProperty;
var __propIsEnum$f = Object.prototype.propertyIsEnumerable;
var __defNormalProp$j = (obj, key, value) => key in obj ? __defProp$j(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$f = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$f.call(b, prop))
      __defNormalProp$j(a, prop, b[prop]);
  if (__getOwnPropSymbols$f)
    for (var prop of __getOwnPropSymbols$f(b)) {
      if (__propIsEnum$f.call(b, prop))
        __defNormalProp$j(a, prop, b[prop]);
    }
  return a;
};
const ReplaceIcon = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues$f({ width: "16", height: "18", viewBox: "0 0 16 18" }, props), /* @__PURE__ */ React.createElement("g", { fill: "#FFF", fillRule: "evenodd" }, /* @__PURE__ */ React.createElement("path", { d: "M3.256 3.468c2.582-2.335 6.447-2.371 9.064-.239l-2.075.079c-.267.01-.475.232-.464.5.01.26.225.464.482.464h.018l3.186-.118c.26-.01.464-.221.464-.482v-.036V3.615l-.118-3.15c-.01-.268-.235-.475-.5-.465-.268.011-.475.233-.464.5l.075 1.975C11.628 1.415 10.031.8 8.324.715 6.21.608 4.178 1.333 2.61 2.754.453 4.708-.462 7.679.224 10.508c.054.221.25.367.468.367.04 0 .075-.003.114-.014.257-.064.418-.325.354-.582-.6-2.486.2-5.096 2.096-6.81zM15.767 6.983c-.064-.258-.325-.418-.582-.354-.257.064-.418.325-.354.582.604 2.486-.2 5.097-2.096 6.81-1.332 1.204-3.004 1.797-4.668 1.797-1.59 0-3.175-.539-4.454-1.603l2.1-.19c.265-.025.461-.257.436-.525-.025-.267-.257-.46-.525-.435l-3.175.285c-.264.025-.46.258-.436.525L2.3 17.05c.021.25.232.44.479.44.014 0 .028 0 .042-.004.265-.025.461-.257.436-.525l-.171-1.932c1.296 1.05 2.885 1.66 4.582 1.746.136.008.271.011.403.011 1.968 0 3.84-.721 5.311-2.05 2.157-1.953 3.072-4.921 2.386-7.753z" })));

var __defProp$i = Object.defineProperty;
var __getOwnPropSymbols$e = Object.getOwnPropertySymbols;
var __hasOwnProp$e = Object.prototype.hasOwnProperty;
var __propIsEnum$e = Object.prototype.propertyIsEnumerable;
var __defNormalProp$i = (obj, key, value) => key in obj ? __defProp$i(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$e = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$e.call(b, prop))
      __defNormalProp$i(a, prop, b[prop]);
  if (__getOwnPropSymbols$e)
    for (var prop of __getOwnPropSymbols$e(b)) {
      if (__propIsEnum$e.call(b, prop))
        __defNormalProp$i(a, prop, b[prop]);
    }
  return a;
};
const NonEditableIcon = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues$e({ width: "15px", height: "15px", viewBox: "0 0 15 15" }, props), /* @__PURE__ */ React.createElement("g", { id: "Polls-Desktop", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React.createElement("g", { id: "WOW-Poll-/-Added-Poll-/-Edit-Mode", transform: "translate(-875.000000, -558.000000)" }, /* @__PURE__ */ React.createElement("g", { id: "Group-6", transform: "translate(871.000000, 553.000000)" }, /* @__PURE__ */ React.createElement("g", { id: "01-Foundation-/-Icon-Medium-24-(Default)-/-01-Actions-/-01-Edit", fill: "#FFFFFF" }, /* @__PURE__ */ React.createElement("path", { d: "M16.679,5.60187506 L18.381,7.30587506 C19.207,8.13287506 19.207,9.47787506 18.381,10.3058751 L10.211,18.4858751 L4,19.9998751 L5.512,13.7818751 L13.682,5.60187506 C14.481,4.79987506 15.878,4.79887506 16.679,5.60187506 Z M8.66091072,16.0462125 L9.973,17.3598751 L15.625,11.7018751 L12.289,8.36087506 L6.637,14.0198751 L7.95422762,15.3386821 L11.1467061,12.1463747 C11.3419735,11.9511178 11.6585559,11.9511262 11.8538129,12.1463936 C12.0490698,12.341661 12.0490613,12.6582435 11.8537939,12.8535004 L8.66091072,16.0462125 Z M16.306,11.0198751 L17.7,9.62387506 C18.15,9.17287506 18.15,8.43787506 17.7,7.98687506 L15.998,6.28287506 C15.561,5.84587506 14.801,5.84687506 14.364,6.28287506 L12.97,7.67887506 L16.306,11.0198751 Z M5.426,18.5738751 L8.995,17.7438751 L6.254,14.9988751 L5.426,18.5738751 Z" })), /* @__PURE__ */ React.createElement(
  "line",
  {
    x1: "7",
    y1: "7",
    x2: "17.9601551",
    y2: "17.9601551",
    stroke: "#FFFFFF",
    strokeLinecap: "square"
  }
)))));

var __defProp$h = Object.defineProperty;
var __getOwnPropSymbols$d = Object.getOwnPropertySymbols;
var __hasOwnProp$d = Object.prototype.hasOwnProperty;
var __propIsEnum$d = Object.prototype.propertyIsEnumerable;
var __defNormalProp$h = (obj, key, value) => key in obj ? __defProp$h(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$d = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$d.call(b, prop))
      __defNormalProp$h(a, prop, b[prop]);
  if (__getOwnPropSymbols$d)
    for (var prop of __getOwnPropSymbols$d(b)) {
      if (__propIsEnum$d.call(b, prop))
        __defNormalProp$h(a, prop, b[prop]);
    }
  return a;
};
const PollOptionPropTypes = PropTypes.shape({
  id: PropTypes.string,
  title: PropTypes.string,
  mediaId: PropTypes.string,
  count: PropTypes.number,
  rating: PropTypes.number
});
const PollPropTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  mediaId: PropTypes.string,
  settings: PropTypes.shape({
    multipleVotes: PropTypes.bool.isRequired,
    votesDisplay: PropTypes.bool.isRequired,
    votersDisplay: PropTypes.bool.isRequired,
    voteRole: PropTypes.string.isRequired,
    resultsVisibility: PropTypes.string.isRequired
  }).isRequired,
  options: PropTypes.arrayOf(PollOptionPropTypes).isRequired
};
const PollActionsPropTypes = {
  changePollTitle: PropTypes.func,
  changePollImage: PropTypes.func,
  updatePollOption: PropTypes.func,
  addOption: PropTypes.func,
  removeOption: PropTypes.func
};
const PollContextPropTypes = {
  poll: PropTypes.shape(__spreadValues$d(__spreadValues$d({}, PollPropTypes), PollActionsPropTypes))
};

var __defProp$g = Object.defineProperty;
var __defProps$4 = Object.defineProperties;
var __getOwnPropDescs$4 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$c = Object.getOwnPropertySymbols;
var __hasOwnProp$c = Object.prototype.hasOwnProperty;
var __propIsEnum$c = Object.prototype.propertyIsEnumerable;
var __defNormalProp$g = (obj, key, value) => key in obj ? __defProp$g(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$c = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$c.call(b, prop))
      __defNormalProp$g(a, prop, b[prop]);
  if (__getOwnPropSymbols$c)
    for (var prop of __getOwnPropSymbols$c(b)) {
      if (__propIsEnum$c.call(b, prop))
        __defNormalProp$g(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$4 = (a, b) => __defProps$4(a, __getOwnPropDescs$4(b));
var __publicField$9 = (obj, key, value) => {
  __defNormalProp$g(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
const PollContext = React.createContext({});
const withPoll = (WrappedComponent) => (props) => {
  return /* @__PURE__ */ React.createElement(PollContext.Consumer, null, (contextValue) => {
    return /* @__PURE__ */ React.createElement(WrappedComponent, __spreadValues$c(__spreadValues$c({}, props), contextValue));
  });
};
class PollContextProvider extends PureComponent {
  constructor(props) {
    var _a;
    super(props);
    __publicField$9(this, "state", {
      changePollTitle: this.changePollTitle.bind(this),
      updatePollOption: this.updatePollOption.bind(this),
      addOption: this.addOption.bind(this),
      removeOption: this.removeOption.bind(this),
      changePollImage: this.changePollImage.bind(this),
      fetchPoll: this.fetchPoll.bind(this),
      vote: this.vote.bind(this),
      unvote: this.unvote.bind(this),
      getVoters: this.getVoters.bind(this),
      poll: this.props.poll
    });
    __publicField$9(this, "syncPoll", async () => {
      let dto;
      const poll = this.populateWithData(this.state.poll);
      if (poll.id) {
        dto = await this.pollApiClient.updatePoll(poll);
      } else {
        dto = await this.pollApiClient.createPoll(poll);
      }
      this.props.setPoll(dto);
      console.debug("polls publish callback");
    });
    this.pollApiClient = (_a = props.settings) == null ? void 0 : _a.pollServiceApi;
  }
  componentWillReceiveProps(props) {
    var _a;
    if (!((_a = props.settings) == null ? void 0 : _a.pollServiceApi) && props.settings.siteToken !== this.props.settings.siteToken) {
      this.fetchPoll();
    }
    if (JSON.stringify(props.poll) !== JSON.stringify(this.props.poll)) {
      this.setState(() => ({ poll: props.poll }));
    }
  }
  componentDidMount() {
    const { editorEvents } = this.props;
    editorEvents == null ? void 0 : editorEvents.subscribe("plugin:publish", this.syncPoll);
  }
  componentWillUnmount() {
    var _a;
    (_a = this.props.editorEvents) == null ? void 0 : _a.unsubscribe("plugin:publish", this.syncPoll);
  }
  async fetchPoll() {
    var _a, _b;
    if (!this.state.poll.id) {
      return;
    }
    const poll = await this.pollApiClient.fetchPoll(this.state.poll.id);
    (_b = (_a = this.props).setPoll) == null ? void 0 : _b.call(_a, poll);
    this.setState(() => ({ poll }));
  }
  populateWithData(poll) {
    const { t } = this.props;
    poll.title = poll.title || t("Poll_Editor_Question_Placeholder");
    poll.options = poll.options.map((option) => __spreadProps$4(__spreadValues$c({}, option), {
      title: option.title || t("Poll_Editor_Answer_Placeholder")
    }));
    return poll;
  }
  updatePoll(poll) {
    this.props.setPoll(Object.assign({}, this.state.poll, poll));
  }
  async vote(optionId) {
    const poll = await this.pollApiClient.vote(this.state.poll.id, optionId);
    this.setState({ poll });
  }
  async unvote(optionId) {
    const poll = await this.pollApiClient.unvote(this.state.poll.id, optionId);
    this.setState({ poll });
  }
  getVoters(optionId, params) {
    return this.pollApiClient.getVoters(this.state.poll.id, optionId, params);
  }
  changePollTitle(title) {
    return this.updatePoll({ title });
  }
  changePollImage(url) {
    const imageData = { image: { src: { url } } };
    return this.updatePoll(imageData);
  }
  updatePollOption(index, option) {
    const poll = cloneDeep(this.state.poll);
    poll.options[index] = option;
    return this.updatePoll({ options: poll.options });
  }
  addOption() {
    const poll = cloneDeep(this.state.poll);
    const imageData = {
      image: {
        src: {
          url: getRandomValue(OPTION_IMAGES_POOL)
        }
      }
    };
    poll.options.push(__spreadValues$c({
      title: ""
    }, imageData));
    return this.updatePoll({ options: poll.options });
  }
  removeOption(index) {
    const poll = cloneDeep(this.state.poll);
    poll.options.splice(index, 1);
    return this.updatePoll({ options: poll.options });
  }
  render() {
    const { children } = this.props;
    return /* @__PURE__ */ React.createElement(PollContext.Provider, { value: this.state }, children);
  }
}
__publicField$9(PollContextProvider, "propTypes", {
  editorEvents: PropTypes.shape({
    subscribe: PropTypes.func,
    unsubscribe: PropTypes.func
  }),
  settings: PropTypes.shape({
    siteToken: PropTypes.string,
    isWebView: PropTypes.bool,
    getSiteMembers: PropTypes.func,
    pollServiceApi: PropTypes.object
  }),
  poll: PropTypes.shape(PollPropTypes),
  setPoll: PropTypes.func,
  children: PropTypes.any,
  t: PropTypes.func
});

var __defProp$f = Object.defineProperty;
var __defProps$3 = Object.defineProperties;
var __getOwnPropDescs$3 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$b = Object.getOwnPropertySymbols;
var __hasOwnProp$b = Object.prototype.hasOwnProperty;
var __propIsEnum$b = Object.prototype.propertyIsEnumerable;
var __defNormalProp$f = (obj, key, value) => key in obj ? __defProp$f(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$b = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$b.call(b, prop))
      __defNormalProp$f(a, prop, b[prop]);
  if (__getOwnPropSymbols$b)
    for (var prop of __getOwnPropSymbols$b(b)) {
      if (__propIsEnum$b.call(b, prop))
        __defNormalProp$f(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$3 = (a, b) => __defProps$3(a, __getOwnPropDescs$3(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$b.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$b)
    for (var prop of __getOwnPropSymbols$b(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$b.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const RCEHelpersPropTypes = {
  rce: PropTypes.shape({
    isViewMode: PropTypes.bool.isRequired,
    setInPluginEditingMode: PropTypes.func,
    helpers: PropTypes.shape({
      handleFileUpload: PropTypes.func
    }),
    getSiteMembers: PropTypes.func
  }).isRequired,
  t: PropTypes.func.isRequired,
  layout: PropTypes.object.isRequired,
  design: PropTypes.object.isRequired
};
const RCEHelpersContext = React.createContext({});
const withRCEHelpers = (WrappedComponent) => (props) => {
  return /* @__PURE__ */ React.createElement(RCEHelpersContext.Consumer, null, (_a) => {
    var _b = _a, { layout, design, t } = _b, rest = __objRest(_b, ["layout", "design", "t"]);
    return /* @__PURE__ */ React.createElement(WrappedComponent, __spreadProps$3(__spreadValues$b({}, props), { rce: rest, t, layout, design }));
  });
};

var styles$6 = {"root":"xzhsv","text":"-Y5dS","input":"ZPqev","small":"iO6x4","medium":"TQkJ-","large":"VeCx3","webview":"BFjBc","endAdornment":"lZe8P","shown":"ZiZWF","value":"_6D9sx","spinner":"FIU1-","spin":"XhsZv"};

var __defProp$e = Object.defineProperty;
var __getOwnPropSymbols$a = Object.getOwnPropertySymbols;
var __hasOwnProp$a = Object.prototype.hasOwnProperty;
var __propIsEnum$a = Object.prototype.propertyIsEnumerable;
var __defNormalProp$e = (obj, key, value) => key in obj ? __defProp$e(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$a = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$a.call(b, prop))
      __defNormalProp$e(a, prop, b[prop]);
  if (__getOwnPropSymbols$a)
    for (var prop of __getOwnPropSymbols$a(b)) {
      if (__propIsEnum$a.call(b, prop))
        __defNormalProp$e(a, prop, b[prop]);
    }
  return a;
};
var __publicField$8 = (obj, key, value) => {
  __defNormalProp$e(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class TextFieldComponent extends React.PureComponent {
  constructor() {
    super(...arguments);
    __publicField$8(this, "$el", React.createRef());
    __publicField$8(this, "state", {
      placeholder: this.props.placeholder,
      rows: 1,
      syncing: false
    });
    __publicField$8(this, "handleWindowResizeEvent", () => setTimeout(() => this.resize()));
    __publicField$8(this, "handleFocus", (e) => {
      e.stopPropagation();
      setTimeout(() => this.resize());
      this.hidePlaceholder();
      this.props.rce.setInPluginEditingMode(true);
    });
    __publicField$8(this, "handleBlur", () => {
      setTimeout(() => this.resize());
      this.showPlaceholder();
      this.props.rce.setInPluginEditingMode(false);
    });
    __publicField$8(this, "handleChange", (event) => {
      this.props.onChange(event.target.value);
      this.resize();
    });
  }
  componentDidMount() {
    const { rce } = this.props;
    const isEditMode = !rce.isViewMode;
    if (isEditMode) {
      this.resize();
    }
    this.handleAutoFocus();
    window == null ? void 0 : window.addEventListener("resize", this.handleWindowResizeEvent);
  }
  componentDidUpdate(props) {
    if (this.props.rce.isViewMode === props.rce.isViewMode) {
      return;
    }
    this.handleAutoFocus();
  }
  handleAutoFocus() {
    var _a;
    const { rce, autofocus } = this.props;
    const isEditMode = !rce.isViewMode;
    if (autofocus && isEditMode) {
      (_a = this.$el.current) == null ? void 0 : _a.focus();
    }
  }
  componentWillUnmount() {
    window == null ? void 0 : window.removeEventListener("resize", this.handleWindowResizeEvent);
  }
  hidePlaceholder() {
    this.setState({ placeholder: "" });
  }
  showPlaceholder() {
    this.setState({ placeholder: this.props.placeholder });
  }
  handleKeyDown(event) {
    if (event.keyCode === 13) {
      event.preventDefault();
    }
  }
  resize() {
    if (!this.$el.current) {
      return;
    }
    const computedStyles = getComputedStyle(this.$el.current);
    const lineHeight = parseInt(computedStyles.lineHeight);
    const paddingTop = parseInt(computedStyles.paddingTop);
    const paddingBottom = parseInt(computedStyles.paddingBottom);
    this.$el.current.rows = 1;
    const { scrollHeight } = this.$el.current;
    this.$el.current.rows = this.state.rows;
    const contentHeight = scrollHeight - (paddingTop + paddingBottom);
    const rows = Math.ceil(clamp(contentHeight / lineHeight, 1, Infinity));
    this.setState({ rows });
  }
  render() {
    const {
      textAutoResize,
      className,
      rce,
      endAdornment,
      style,
      children,
      startAdornment,
      maxLength,
      disabled,
      value
    } = this.props;
    const { placeholder, rows, syncing } = this.state;
    if (rce.isViewMode || rce.isPreview) {
      return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
        "p",
        {
          style,
          className: cls(
            styles$6.text,
            className,
            textAutoResize && {
              [styles$6.small]: value.length > 120,
              [styles$6.medium]: value.length <= 120,
              [styles$6.large]: value.length <= 80
            },
            {
              [styles$6.webview]: rce.isWebView
            }
          )
        },
        startAdornment,
        children,
        /* @__PURE__ */ React.createElement("span", { className: styles$6.value }, this.props.value || this.props.placeholder)
      ));
    }
    return /* @__PURE__ */ React.createElement("div", { className: styles$6.root }, startAdornment, /* @__PURE__ */ React.createElement(
      "textarea",
      {
        disabled,
        maxLength,
        style,
        ref: this.$el,
        onChange: this.handleChange,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        placeholder,
        value,
        rows,
        onKeyDown: this.handleKeyDown,
        className: cls(
          styles$6.input,
          className,
          textAutoResize && {
            [styles$6.small]: value.length > 120,
            [styles$6.medium]: value.length <= 120,
            [styles$6.large]: value.length <= 80
          }
        ),
        onClick: void 0
      }
    ), /* @__PURE__ */ React.createElement(
      "span",
      {
        className: cls(styles$6.endAdornment, {
          [styles$6.shown]: syncing
        })
      },
      syncing ? /* @__PURE__ */ React.createElement(LoaderIcon, { className: styles$6.spinner }) : endAdornment
    ));
  }
}
const TextField = withRCEHelpers(TextFieldComponent);
TextFieldComponent.defaultProps = {
  maxLength: 500,
  disabled: false
};
TextFieldComponent.propTypes = __spreadValues$a({
  autofocus: PropTypes.bool,
  maxLength: PropTypes.number,
  value: PropTypes.string,
  disabled: PropTypes.string,
  className: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string.isRequired,
  textAutoResize: PropTypes.bool,
  startAdornment: PropTypes.node,
  endAdornment: PropTypes.node
}, RCEHelpersPropTypes);

const ImageUploadPropTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  className: PropTypes.string,
  imagesPool: PropTypes.array,
  small: PropTypes.bool,
  disabled: PropTypes.bool
};

var styles$5 = {"container":"zCaNg","disabled":"p7mLi","imageInput":"keHvI","overlay":"_1hEJa","text":"AwCCZ","shown":"wUtNm","hide":"IPELO","spinner":"RWk8F","spin":"FzxGJ"};

var __defProp$d = Object.defineProperty;
var __defProps$2 = Object.defineProperties;
var __getOwnPropDescs$2 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$9 = Object.getOwnPropertySymbols;
var __hasOwnProp$9 = Object.prototype.hasOwnProperty;
var __propIsEnum$9 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$d = (obj, key, value) => key in obj ? __defProp$d(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$9 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$9.call(b, prop))
      __defNormalProp$d(a, prop, b[prop]);
  if (__getOwnPropSymbols$9)
    for (var prop of __getOwnPropSymbols$9(b)) {
      if (__propIsEnum$9.call(b, prop))
        __defNormalProp$d(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$2 = (a, b) => __defProps$2(a, __getOwnPropDescs$2(b));
var __publicField$7 = (obj, key, value) => {
  __defNormalProp$d(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class ImageUploadComponent extends PureComponent {
  constructor() {
    super(...arguments);
    __publicField$7(this, "state", {
      value: this.props.value || getRandomValue(POLL_IMAGES_POOL),
      backgroundImage: null,
      loading: false
    });
    __publicField$7(this, "$label", React.createRef());
    __publicField$7(this, "handleFileUpload", ({ data }) => {
      this.setState(
        {
          value: `https://static.wixstatic.com/media/${data.file_name}`,
          loading: false
        },
        () => {
          this.updateBackgroundImage();
          this.sync();
        }
      );
    });
    __publicField$7(this, "handleFileReadLoad", (backgroundImage, file) => {
      const { helpers } = this.props.rce;
      this.setState({ backgroundImage: `url(${backgroundImage})`, loading: false });
      if (helpers == null ? void 0 : helpers.handleFileUpload) {
        this.setState({ loading: true });
        helpers.handleFileUpload(file, this.handleFileUpload);
      }
    });
    __publicField$7(this, "handleInputChange", (e) => {
      this.handleFileChange(Array.from(e.target.files));
      e.target.value = null;
    });
    __publicField$7(this, "handleFileChange", ([file]) => {
      const reader = new FileReader();
      this.setState({ loading: true });
      reader.onload = (e) => this.handleFileReadLoad(e.target.result, file);
      reader.readAsDataURL(file);
    });
    __publicField$7(this, "handleKeyPress", (e) => {
      var _a;
      const enterOrSpace = e.key === "Enter" || e.key === " " || e.key === "Spacebar" || e.which === 13 || e.which === 32;
      if (enterOrSpace) {
        e.preventDefault();
        (_a = this.$label.current) == null ? void 0 : _a.click();
      }
    });
    __publicField$7(this, "handleFocus", (e) => {
      e.stopPropagation();
      const { rce } = this.props;
      rce.setInPluginEditingMode(true);
    });
    __publicField$7(this, "handleBlur", () => {
      const { rce } = this.props;
      rce.setInPluginEditingMode(false);
    });
  }
  componentWillReceiveProps(props) {
    const { value, contentRect } = props;
    const { value: prevValue, contentRect: prevContentRect } = this.props;
    if (value !== prevValue) {
      this.setState({ value }, () => this.updateBackgroundImage());
    }
    if (JSON.stringify(contentRect.bounds) !== JSON.stringify(prevContentRect.bounds)) {
      this.updateBackgroundImage(contentRect.bounds);
    }
  }
  sync() {
    this.props.onChange(this.state.value);
  }
  updateBackgroundImage(bounds = this.props.contentRect.bounds) {
    const { value } = this.state;
    if (!bounds.width || !bounds.height) {
      return null;
    }
    const backgroundImage = `url(${getScaleImageSrc(value, bounds.width, bounds.height)})`;
    this.setState(() => ({
      backgroundImage
    }));
  }
  render() {
    const { className, rce, small, disabled, measureRef, style = {} } = this.props;
    const { loading, backgroundImage } = this.state;
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        ref: measureRef,
        className: cls(styles$5.container, className, {
          [styles$5.disabled]: rce.isViewMode || disabled
        }),
        style: __spreadProps$2(__spreadValues$9({}, style), { backgroundImage }),
        tabIndex: rce.isViewMode ? -1 : 0,
        "aria-hidden": rce.isViewMode,
        role: "button",
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onKeyPress: this.handleKeyPress
      },
      /* @__PURE__ */ React.createElement("label", { ref: this.$label }, /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "file",
          disabled: rce.isViewMode || disabled,
          onChange: this.handleInputChange,
          accept: "image/*",
          tabIndex: -1,
          className: styles$5.imageInput
        }
      ), /* @__PURE__ */ React.createElement(
        "div",
        {
          className: cls(styles$5.overlay, {
            [styles$5.shown]: loading
          })
        },
        loading ? /* @__PURE__ */ React.createElement(
          LoaderIcon,
          {
            width: small ? 24 : 48,
            height: small ? 24 : 48,
            className: styles$5.spinner
          }
        ) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ReplaceIcon, null), /* @__PURE__ */ React.createElement(
          "p",
          {
            className: cls(styles$5.text, {
              [styles$5.hide]: small
            })
          },
          "Change Image"
        ))
      ))
    );
  }
}
__publicField$7(ImageUploadComponent, "propTypes", __spreadValues$9(__spreadValues$9({}, ImageUploadPropTypes), RCEHelpersPropTypes));
__publicField$7(ImageUploadComponent, "defaultProps", {
  imagesPool: [],
  disabled: false
});
const ImageUpload = withContentRect("bounds")(withRCEHelpers(ImageUploadComponent));

var styles$4 = {"title":"tyacT","image":"_4sCnc","webview":"zWD4h"};

var __defProp$c = Object.defineProperty;
var __getOwnPropSymbols$8 = Object.getOwnPropertySymbols;
var __hasOwnProp$8 = Object.prototype.hasOwnProperty;
var __propIsEnum$8 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$c = (obj, key, value) => key in obj ? __defProp$c(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$8 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$8.call(b, prop))
      __defNormalProp$c(a, prop, b[prop]);
  if (__getOwnPropSymbols$8)
    for (var prop of __getOwnPropSymbols$8(b)) {
      if (__propIsEnum$8.call(b, prop))
        __defNormalProp$c(a, prop, b[prop]);
    }
  return a;
};
class PollHeaderComponent extends PureComponent {
  render() {
    var _a, _b, _c;
    const { poll, changePollTitle, changePollImage, layout, t, rce } = this.props;
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: cls(styles$4.header, {
          [styles$4.webview]: rce.isWebView
        })
      },
      /* @__PURE__ */ React.createElement(
        TextField,
        {
          autofocus: true,
          textAutoResize: true,
          maxLength: 160,
          className: styles$4.title,
          value: poll.title,
          onChange: changePollTitle,
          placeholder: t("Poll_Editor_Question_Placeholder")
        }
      ),
      ((_a = layout.poll) == null ? void 0 : _a.enableImage) && /* @__PURE__ */ React.createElement(
        ImageUpload,
        {
          disabled: rce.isPreview,
          className: styles$4.image,
          value: (_c = (_b = poll.image) == null ? void 0 : _b.src) == null ? void 0 : _c.url,
          onChange: changePollImage
        }
      )
    );
  }
}
const PollHeader = withRCEHelpers(withPoll(PollHeaderComponent));
PollHeaderComponent.propTypes = __spreadValues$8(__spreadValues$8({}, PollContextPropTypes), RCEHelpersPropTypes);

const VotedUsersProps = {
  siteMembers: PropTypes.array,
  option: PropTypes.object,
  showVoters: PropTypes.bool,
  showVotes: PropTypes.bool
};

var styles$3 = {"container":"jRNOr","webview":"aZEqB","avatar_list":"_7BBhm","avatar":"HzKKg","user_avatar":"_1d8NH","modal":"FmafX","voted_users_modal":"kvSip","overlay":"EBV11","user_card":"fZGLR","user_name":"uJtDe","voted_users_modal_header":"TUGFv","cta":"zDq-F","close_icon":"gjvN8","title":"O2rFH","member_list_container":"_0adei","member_list":"Kk1iM","loader":"_5sbPO","anonymous_counter":"gxJ9o","spinner":"EmApn","spin":"tFWeF"};

var __defProp$b = Object.defineProperty;
var __getOwnPropSymbols$7 = Object.getOwnPropertySymbols;
var __hasOwnProp$7 = Object.prototype.hasOwnProperty;
var __propIsEnum$7 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$b = (obj, key, value) => key in obj ? __defProp$b(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$7 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$7.call(b, prop))
      __defNormalProp$b(a, prop, b[prop]);
  if (__getOwnPropSymbols$7)
    for (var prop of __getOwnPropSymbols$7(b)) {
      if (__propIsEnum$7.call(b, prop))
        __defNormalProp$b(a, prop, b[prop]);
    }
  return a;
};
const FallbackAvatar = (props) => {
  return /* @__PURE__ */ React.createElement(
    "svg",
    __spreadValues$7({
      width: "36",
      height: "36",
      viewBox: "0 0 36 36",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props),
    /* @__PURE__ */ React.createElement("mask", { id: "mask0_51:19729", maskUnits: "userSpaceOnUse", x: "0", y: "0", width: "36", height: "36" }, /* @__PURE__ */ React.createElement("circle", { cx: "18", cy: "18", r: "18", fill: "#E6E6E6" }), /* @__PURE__ */ React.createElement("circle", { cx: "18", cy: "18", r: "18", fill: "#E6E6E6" })),
    /* @__PURE__ */ React.createElement("g", { mask: "url(#mask0_51:19729)" }, /* @__PURE__ */ React.createElement("circle", { cx: "18", cy: "18", r: "18", fill: "#F0F0F0" }), /* @__PURE__ */ React.createElement("circle", { cx: "18", cy: "14", r: "7", fill: "#A6A6A6" }), /* @__PURE__ */ React.createElement("circle", { cx: "18", cy: "41", r: "18", fill: "#A6A6A6" }))
  );
};

function VoterAvatar(props) {
  const { className, src, memberInfo, size } = props;
  const { t } = useContext(RicosContext);
  return src ? /* @__PURE__ */ React.createElement(
    Image,
    {
      uri: src,
      displayMode: "fill",
      alt: memberInfo.name || t("Polls_Plugin_User_Avatar_Alt"),
      height: size.height,
      width: size.width,
      containerProps: {
        className,
        style: size
      }
    }
  ) : /* @__PURE__ */ React.createElement(FallbackAvatar, { className });
}

var __defProp$a = Object.defineProperty;
var __getOwnPropSymbols$6 = Object.getOwnPropertySymbols;
var __hasOwnProp$6 = Object.prototype.hasOwnProperty;
var __propIsEnum$6 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$a = (obj, key, value) => key in obj ? __defProp$a(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$6 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$6.call(b, prop))
      __defNormalProp$a(a, prop, b[prop]);
  if (__getOwnPropSymbols$6)
    for (var prop of __getOwnPropSymbols$6(b)) {
      if (__propIsEnum$6.call(b, prop))
        __defNormalProp$a(a, prop, b[prop]);
    }
  return a;
};
var __publicField$6 = (obj, key, value) => {
  __defNormalProp$a(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class VotedUsersModalComponent extends Component {
  constructor() {
    super(...arguments);
    __publicField$6(this, "state", {
      members: [],
      moreItems: true,
      cursor: void 0
    });
    __publicField$6(this, "fetchVoters", async () => {
      const { getSiteMember } = this.props;
      const { members, cursor } = this.state;
      try {
        const { voters, moreItems } = await this.props.fetchVoters({ cursor, limit: 10 });
        this.setState({
          members: members.concat(voters.map((member) => member.memberId).map(getSiteMember)),
          cursor: voters[voters.length - 1].memberId,
          moreItems
        });
      } catch (error) {
      }
    });
  }
  render() {
    const { t, option, onRequestClose } = this.props;
    const { members, moreItems } = this.state;
    return /* @__PURE__ */ React.createElement("div", { className: styles$3.voted_users_modal }, /* @__PURE__ */ React.createElement("div", { className: styles$3.voted_users_modal_header }, /* @__PURE__ */ React.createElement("p", { className: styles$3.title }, t("Poll_Viewer_VoteCount_Modal_Voters_Header", {
      count: option.count,
      number: option.count
    })), /* @__PURE__ */ React.createElement(RemoveIcon, { onClick: onRequestClose, className: styles$3.close_icon })), /* @__PURE__ */ React.createElement(
      InfiniteScroll,
      {
        className: styles$3.member_list_container,
        initialLoad: true,
        hasMore: moreItems,
        loadMore: this.fetchVoters,
        loader: /* @__PURE__ */ React.createElement("div", { className: styles$3.loader }, /* @__PURE__ */ React.createElement(LoaderIcon, { width: 24, height: 24, className: styles$3.spinner }))
      },
      /* @__PURE__ */ React.createElement("ul", { className: styles$3.member_list }, members.map((member) => {
        var _a;
        return member ? /* @__PURE__ */ React.createElement("li", { key: member.siteMemberId }, /* @__PURE__ */ React.createElement("div", { className: styles$3.user_card }, /* @__PURE__ */ React.createElement(
          VoterAvatar,
          {
            className: styles$3.user_avatar,
            memberInfo: member,
            src: member.imageUrl,
            size: {
              width: 36,
              height: 36
            }
          }
        ), /* @__PURE__ */ React.createElement("span", { className: styles$3.user_name }, ((_a = member.name) == null ? void 0 : _a.nick) || t("Poll_Viewer_VoteCount_Modal_Voters_Private_Voter")))) : null;
      }))
    ), option.anonymousCount ? /* @__PURE__ */ React.createElement("p", { className: styles$3.anonymous_counter }, t("Poll_Viewer_VoteCount_Modal_Voters_Anonymous", {
      anonNumber: option.anonymousCount
    })) : null);
  }
}
__publicField$6(VotedUsersModalComponent, "propTypes", __spreadValues$6({}, RCEHelpersPropTypes));
const VotedUsersModal = withRCEHelpers(VotedUsersModalComponent);

var __defProp$9 = Object.defineProperty;
var __getOwnPropSymbols$5 = Object.getOwnPropertySymbols;
var __hasOwnProp$5 = Object.prototype.hasOwnProperty;
var __propIsEnum$5 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$9 = (obj, key, value) => key in obj ? __defProp$9(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5.call(b, prop))
      __defNormalProp$9(a, prop, b[prop]);
  if (__getOwnPropSymbols$5)
    for (var prop of __getOwnPropSymbols$5(b)) {
      if (__propIsEnum$5.call(b, prop))
        __defNormalProp$9(a, prop, b[prop]);
    }
  return a;
};
var __publicField$5 = (obj, key, value) => {
  __defNormalProp$9(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class VotedUsersComponent extends PureComponent {
  constructor() {
    super(...arguments);
    __publicField$5(this, "state", {
      isOpen: false,
      $container: null
    });
    __publicField$5(this, "getContainer", () => this.state.$container);
    __publicField$5(this, "closeModal", () => this.setState({ isOpen: false }));
    __publicField$5(this, "openModal", (e) => {
      const { showVoters, rce } = this.props;
      e.preventDefault();
      if (e.keyCode || !showVoters || rce.preventInteraction) {
        return;
      }
      this.setState({ isOpen: this.props.rce.isViewMode });
    });
  }
  getSiteMember(id) {
    var _a, _b;
    const siteMembers = ((_b = (_a = this.props.rce).getSiteMembers) == null ? void 0 : _b.call(_a)) || [];
    return siteMembers.find((siteMember) => siteMember.siteMemberId === id);
  }
  getSiteMembers() {
    var _a, _b;
    const { rce, option, showVoters } = this.props;
    const siteMembers = ((_a = rce.getSiteMembers) == null ? void 0 : _a.call(rce)) || [];
    if (!showVoters || !siteMembers) {
      return [];
    }
    return ((_b = option.latestVoters) == null ? void 0 : _b.map(this.getSiteMember.bind(this))) || [];
  }
  renderMember(member) {
    if (!member) {
      return null;
    }
    return /* @__PURE__ */ React.createElement("li", { key: member.siteMemberId, className: styles$3.avatar }, /* @__PURE__ */ React.createElement(
      VoterAvatar,
      {
        className: styles$3.avatar,
        memberInfo: member,
        src: member.imageUrl,
        size: {
          width: 20,
          height: 20
        }
      }
    ));
  }
  render() {
    var _a, _b;
    const { option, t, showResults, showVotes, showVoters, fetchVoters, rce, isMobile } = this.props;
    const { isOpen, $container } = this.state;
    if (!showResults || !showVotes || !option.count) {
      return null;
    }
    const zIndex = this.props.zIndexService.getZIndex(isMobile ? "DRAWER" : "DIALOG");
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
      "div",
      {
        className: cls(styles$3.container, {
          [styles$3.cta]: showVoters && ((_a = option.latestVoters) == null ? void 0 : _a.length),
          [styles$3.webview]: rce.isWebView
        }),
        ref: ($container2) => this.setState({ $container: $container2 }),
        onClick: this.openModal,
        onKeyPress: this.openModal,
        role: "button",
        "aria-haspopup": "dialog",
        tabIndex: 0
      },
      /* @__PURE__ */ React.createElement("ul", { className: styles$3.avatar_list }, this.getSiteMembers().map(this.renderMember)),
      /* @__PURE__ */ React.createElement("span", null, t("Poll_Viewer_VoteCount", { number: option.count || 0 }))
    ), $container && ((_b = option.latestVoters) == null ? void 0 : _b.length) ? /* @__PURE__ */ React.createElement(
      ReactModal,
      {
        isOpen,
        onRequestClose: this.closeModal,
        parentSelector: this.getContainer,
        className: cls(styles$3.modal),
        overlayClassName: cls(styles$3.overlay),
        style: { content: { zIndex } }
      },
      /* @__PURE__ */ React.createElement(
        VotedUsersModal,
        {
          option,
          fetchVoters,
          getSiteMember: this.getSiteMember.bind(this),
          onRequestClose: this.closeModal
        }
      )
    ) : null);
  }
}
__publicField$5(VotedUsersComponent, "propTypes", __spreadValues$5({}, VotedUsersProps));
const VotedUsers = withRicosContext(withZIndexContext(withRCEHelpers(VotedUsersComponent)));

const OptionPropTypes = {
  option: PollOptionPropTypes,
  removeEnabled: PropTypes.bool,
  update: PropTypes.func,
  remove: PropTypes.func,
  vote: PropTypes.func,
  unvote: PropTypes.func,
  poll: PropTypes.object,
  imageEnabled: PropTypes.bool,
  voteEnabled: PropTypes.bool,
  showResults: PropTypes.bool
};

var __defProp$8 = Object.defineProperty;
var __defProps$1 = Object.defineProperties;
var __getOwnPropDescs$1 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$4 = Object.getOwnPropertySymbols;
var __hasOwnProp$4 = Object.prototype.hasOwnProperty;
var __propIsEnum$4 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$8 = (obj, key, value) => key in obj ? __defProp$8(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4.call(b, prop))
      __defNormalProp$8(a, prop, b[prop]);
  if (__getOwnPropSymbols$4)
    for (var prop of __getOwnPropSymbols$4(b)) {
      if (__propIsEnum$4.call(b, prop))
        __defNormalProp$8(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1 = (a, b) => __defProps$1(a, __getOwnPropDescs$1(b));
var __publicField$4 = (obj, key, value) => {
  __defNormalProp$8(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class PollOptionBase extends React.PureComponent {
  constructor() {
    super(...arguments);
    __publicField$4(this, "state", {
      loading: false,
      checked: this.isUserChoice()
    });
    __publicField$4(this, "handleRemove", (e) => {
      e.stopPropagation();
      this.props.remove();
    });
    __publicField$4(this, "handleVoteClick", async (e) => {
      var _a;
      const { validateUser, onBeforeVote, preventInteraction, preventVoting } = this.props.rce;
      const vote = (_a = this.props.poll.settings.permissions) == null ? void 0 : _a.vote;
      const onVoteClick = onBeforeVote || validateUser;
      e.preventDefault();
      if (e.keyCode || preventInteraction || preventVoting) {
        return;
      }
      if (onVoteClick) {
        onVoteClick(vote).then(this.toggleVote.bind(this), () => {
        });
      } else {
        this.toggleVote();
      }
    });
    __publicField$4(this, "handleTitleChange", (title) => {
      const { update, option } = this.props;
      return update(__spreadProps$1(__spreadValues$4({}, option), { title }));
    });
    __publicField$4(this, "handleImageChange", (url) => {
      const { update, option } = this.props;
      const newOption = __spreadProps$1(__spreadValues$4({}, option), { image: { src: { url } } });
      return update(newOption);
    });
  }
  isEditAllowed() {
    return !this.props.option.count && !this.props.rce.isPreview;
  }
  isUserChoice() {
    var _a;
    const { poll, option } = this.props;
    return !!((_a = poll.ownVotes) == null ? void 0 : _a.includes(option.id));
  }
  isViewMode() {
    return this.props.rce.isViewMode;
  }
  isGridLayout() {
    var _a;
    return ((_a = this.props.layout.poll) == null ? void 0 : _a.type) === LAYOUTS.GRID;
  }
  isListLayout() {
    var _a;
    return ((_a = this.props.layout.poll) == null ? void 0 : _a.type) === LAYOUTS.LIST;
  }
  isImageEnabled() {
    var _a;
    return (_a = this.props.layout.options) == null ? void 0 : _a.enableImage;
  }
  async toggleVote() {
    this.setState({ loading: true });
    try {
      if (this.isUserChoice()) {
        await this.props.unvote(this.props.option.id);
        this.setState({ checked: false });
      } else {
        await this.props.vote(this.props.option.id);
        this.setState({ checked: true });
      }
    } catch (error) {
    } finally {
      this.setState({ loading: false });
    }
  }
  getVotePercentage() {
    const { option } = this.props;
    return option.rating || 0;
  }
  render() {
    if (this.isViewMode()) {
      return this.renderViewMode();
    }
    return this.renderEditMode();
  }
}
__publicField$4(PollOptionBase, "propTypes", __spreadValues$4(__spreadValues$4({}, OptionPropTypes), RCEHelpersPropTypes));

var styles$2 = {"option":"jTvQj","user_choice":"Co8-P","check":"pKmda","image":"xes4x","input":"jyhqx","title":"Dhz8X","centered":"o6BId","with_result":"UBash","list":"_8eUJ4","with_image":"-D6Ev","progress":"X8-o-","progress_value":"hrSWN","label":"I8Wt1","cta":"iyRGA","adornment_icon":"ZEoQ9","remove":"DuEki","overlay":"wRkVA","shown":"jhEzg","dark":"_3DHty","spinner":"_2dNdr","spin":"Jm7at"};

var __defProp$7 = Object.defineProperty;
var __defNormalProp$7 = (obj, key, value) => key in obj ? __defProp$7(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField$3 = (obj, key, value) => {
  __defNormalProp$7(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class PollGridOption extends PollOptionBase {
  getCustomStyle() {
    var _a;
    const { design } = this.props;
    const borderRadius = parseInt((_a = design.options) == null ? void 0 : _a.borderRadius);
    return {
      input: {
        borderRadius: this.isImageEnabled() ? `0 0 ${borderRadius}px ${borderRadius}px` : `${borderRadius}px`
      },
      image: {
        borderRadius: `${borderRadius}px ${borderRadius}px 0 0`
      }
    };
  }
  renderEditMode() {
    const { design, option, removeEnabled, dark, t } = this.props;
    const style = this.getCustomStyle();
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: cls(styles$2.option, {
          [styles$2.with_image]: this.isImageEnabled(),
          [styles$2.dark]: dark
        }),
        style: design.options
      },
      this.isImageEnabled() && /* @__PURE__ */ React.createElement(
        ImageUpload,
        {
          className: styles$2.image,
          value: option.image.src.url,
          onChange: this.handleImageChange,
          style: style.image,
          disabled: !this.isEditAllowed()
        }
      ),
      /* @__PURE__ */ React.createElement("div", { className: styles$2.title }, /* @__PURE__ */ React.createElement(
        TextField,
        {
          disabled: !this.isEditAllowed(),
          maxLength: 60,
          style: style.input,
          className: cls(styles$2.input, styles$2.centered),
          value: option.title,
          placeholder: t("Poll_Editor_Answer_Placeholder"),
          onChange: this.handleTitleChange,
          endAdornment: /* @__PURE__ */ React.createElement(React.Fragment, null, !this.isEditAllowed() ? /* @__PURE__ */ React.createElement(Tooltip, { content: t("Poll_Editor_Answer_Error_NoEdit_Tooltip") }, /* @__PURE__ */ React.createElement(NonEditableIcon, { className: styles$2.adornment_icon })) : null, removeEnabled && /* @__PURE__ */ React.createElement(RemoveIcon, { onClick: this.handleRemove, className: styles$2.remove }))
        }
      ))
    );
  }
  renderViewMode() {
    const { design, option, showResults, dark, t } = this.props;
    const { loading, checked } = this.state;
    const style = this.getCustomStyle();
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: cls(styles$2.option, styles$2.grid, styles$2.cta, {
          [styles$2.with_image]: this.isImageEnabled(),
          [styles$2.user_choice]: this.isUserChoice(),
          [styles$2.dark]: dark
        }),
        style: design.option,
        onClick: this.handleVoteClick,
        onKeyPress: this.handleVoteClick,
        "aria-label": checked ? t("Poll_Viewer_Option_AriaLabel_Checked") : t("Poll_Viewer_Option_AriaLabel_Unchecked"),
        tabIndex: 0,
        role: "button"
      },
      /* @__PURE__ */ React.createElement(
        "div",
        {
          className: cls(styles$2.overlay, {
            [styles$2.shown]: loading
          }),
          style: design.option
        },
        /* @__PURE__ */ React.createElement(LoaderIcon, { className: styles$2.spinner, width: 36, height: 36 })
      ),
      this.isImageEnabled() && /* @__PURE__ */ React.createElement(ImageUpload, { className: styles$2.image, value: option.image.src.url, style: style.image }),
      /* @__PURE__ */ React.createElement("div", { className: styles$2.title }, /* @__PURE__ */ React.createElement(
        TextField,
        {
          maxLength: 60,
          style: style.input,
          className: cls(styles$2.input, styles$2.centered, {
            [styles$2.with_result]: showResults
          }),
          value: option.title,
          placeholder: t("Poll_Editor_Answer_Placeholder")
        },
        /* @__PURE__ */ React.createElement(
          "span",
          {
            className: styles$2.progress,
            style: {
              width: `${this.getVotePercentage()}%`
            }
          }
        ),
        showResults && /* @__PURE__ */ React.createElement("span", { className: styles$2.progress_value }, this.getVotePercentage(), "%")
      )),
      /* @__PURE__ */ React.createElement(
        "div",
        {
          className: styles$2.check,
          style: {
            color: dark ? "#000" : design.poll.background
          }
        },
        /* @__PURE__ */ React.createElement(CheckIcon, { className: styles$2.icon })
      )
    );
  }
}
__publicField$3(PollGridOption, "propTypes", PollOptionBase.propTypes);

var __defProp$6 = Object.defineProperty;
var __defNormalProp$6 = (obj, key, value) => key in obj ? __defProp$6(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField$2 = (obj, key, value) => {
  __defNormalProp$6(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class PollListOption extends PollOptionBase {
  getCustomStyle() {
    var _a;
    const { design } = this.props;
    const borderRadius = parseInt((_a = design.options) == null ? void 0 : _a.borderRadius);
    return {
      input: {
        borderRadius
      },
      image: {
        borderRadius
      }
    };
  }
  renderViewMode() {
    var _a, _b;
    const { design, option, showResults, dark, t } = this.props;
    const { loading, checked } = this.state;
    const style = this.getCustomStyle();
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: cls(styles$2.option, styles$2.list, styles$2.cta, {
          [styles$2.with_image]: this.isImageEnabled() ? (_a = option.image) == null ? void 0 : _a.src.url : null,
          [styles$2.user_choice]: this.isUserChoice(),
          [styles$2.dark]: dark
        }),
        style: design.option,
        onClick: this.handleVoteClick,
        onKeyPress: this.handleVoteClick,
        "aria-label": checked ? t("Poll_Viewer_Option_AriaLabel_Checked") : t("Poll_Viewer_Option_AriaLabel_Unchecked"),
        tabIndex: 0,
        role: "button"
      },
      /* @__PURE__ */ React.createElement(
        "div",
        {
          className: cls(styles$2.overlay, {
            [styles$2.shown]: loading
          }),
          style: design.option
        },
        /* @__PURE__ */ React.createElement(LoaderIcon, { className: styles$2.spinner, width: 36, height: 36 })
      ),
      /* @__PURE__ */ React.createElement("div", { className: styles$2.title }, /* @__PURE__ */ React.createElement(
        TextField,
        {
          maxLength: 60,
          style: style.input,
          className: cls(styles$2.input, {
            [styles$2.with_result]: showResults
          }),
          value: option.title,
          placeholder: t("Poll_Editor_Answer_Placeholder"),
          startAdornment: /* @__PURE__ */ React.createElement(
            ImageUpload,
            {
              className: styles$2.image,
              value: (_b = option.image) == null ? void 0 : _b.src.url,
              style: style.image,
              small: true
            }
          )
        },
        /* @__PURE__ */ React.createElement(
          "span",
          {
            className: styles$2.progress,
            style: {
              width: `${this.getVotePercentage()}%`
            }
          }
        ),
        showResults && /* @__PURE__ */ React.createElement("span", { className: styles$2.progress_value }, this.getVotePercentage(), "%")
      )),
      /* @__PURE__ */ React.createElement(
        "div",
        {
          className: styles$2.check,
          style: {
            color: dark ? "#000" : design.poll.background
          }
        },
        /* @__PURE__ */ React.createElement(CheckIcon, { className: styles$2.icon })
      )
    );
  }
  renderEditMode() {
    var _a;
    const { design, option, removeEnabled, t, dark } = this.props;
    const style = this.getCustomStyle();
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: cls(styles$2.option, styles$2.list, {
          [styles$2.with_image]: this.isImageEnabled(),
          [styles$2.dark]: dark
        }),
        style: design.option
      },
      /* @__PURE__ */ React.createElement("div", { className: styles$2.title }, /* @__PURE__ */ React.createElement(
        TextField,
        {
          maxLength: 60,
          style: style.input,
          className: styles$2.input,
          value: option.title,
          disabled: !this.isEditAllowed(),
          placeholder: t("Poll_Editor_Answer_Placeholder"),
          onChange: this.handleTitleChange,
          endAdornment: /* @__PURE__ */ React.createElement(React.Fragment, null, !this.isEditAllowed() ? /* @__PURE__ */ React.createElement(Tooltip, { content: t("Poll_Editor_Answer_Error_NoEdit_Tooltip") }, /* @__PURE__ */ React.createElement(NonEditableIcon, { className: styles$2.adornment_icon })) : null, removeEnabled && /* @__PURE__ */ React.createElement(RemoveIcon, { onClick: this.handleRemove, className: styles$2.remove })),
          startAdornment: /* @__PURE__ */ React.createElement(
            ImageUpload,
            {
              disabled: !this.isEditAllowed(),
              className: styles$2.image,
              value: (_a = option.image) == null ? void 0 : _a.src.url,
              onChange: this.handleImageChange,
              style: style.image,
              small: true
            }
          )
        }
      ))
    );
  }
}
__publicField$2(PollListOption, "propTypes", PollOptionBase.propTypes);

var styles$1 = {"option":"q7O0b","user_choice":"_5l6s0","check":"I0f9o","image":"vF91-","input":"EIakV","title":"_7g5gv","centered":"_7UL1-","with_result":"cEDY8","list":"V-bry","with_image":"VP8S2","progress":"qvElD","progress_value":"_7dSok","label":"YHkn6","cta":"QtOjQ","adornment_icon":"IItZT","remove":"wnldL","overlay":"e2p2u","shown":"xiobw","dark":"eWlsU","spinner":"dhL-O","spin":"YYFMW","grid":"SFAhi"};

var __defProp$5 = Object.defineProperty;
var __defNormalProp$5 = (obj, key, value) => key in obj ? __defProp$5(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField$1 = (obj, key, value) => {
  __defNormalProp$5(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class PollListOptionWebview extends PollOptionBase {
  render() {
    const { option, dark, t } = this.props;
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: cls(styles$1.option, styles$1.list, {
          [styles$1.with_image]: this.isImageEnabled() && option.image.src.url,
          [styles$1.dark]: dark
        })
      },
      /* @__PURE__ */ React.createElement("div", { className: styles$1.title }, /* @__PURE__ */ React.createElement(
        TextField,
        {
          maxLength: 60,
          className: cls(styles$1.input),
          value: option.title,
          placeholder: t("Poll_Editor_Answer_Placeholder"),
          startAdornment: /* @__PURE__ */ React.createElement(ImageUpload, { className: styles$1.image, value: option.image.src.url, small: true })
        }
      ))
    );
  }
}
__publicField$1(PollListOptionWebview, "propTypes", PollOptionBase.propTypes);

var __defProp$4 = Object.defineProperty;
var __defNormalProp$4 = (obj, key, value) => key in obj ? __defProp$4(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp$4(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class PollGridOptionWebview extends PollOptionBase {
  render() {
    const { option, dark, t } = this.props;
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: cls(styles$1.option, styles$1.grid, {
          [styles$1.with_image]: this.isImageEnabled(),
          [styles$1.dark]: dark
        })
      },
      this.isImageEnabled() && /* @__PURE__ */ React.createElement(ImageUpload, { className: styles$1.image, value: option.image.src.url }),
      /* @__PURE__ */ React.createElement("div", { className: styles$1.title }, /* @__PURE__ */ React.createElement(
        TextField,
        {
          maxLength: 60,
          className: cls(styles$1.input),
          value: option.title,
          placeholder: t("Poll_Editor_Answer_Placeholder")
        }
      ))
    );
  }
}
__publicField(PollGridOptionWebview, "propTypes", PollOptionBase.propTypes);

var __defProp$3 = Object.defineProperty;
var __getOwnPropSymbols$3 = Object.getOwnPropertySymbols;
var __hasOwnProp$3 = Object.prototype.hasOwnProperty;
var __propIsEnum$3 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3 = (obj, key, value) => key in obj ? __defProp$3(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3.call(b, prop))
      __defNormalProp$3(a, prop, b[prop]);
  if (__getOwnPropSymbols$3)
    for (var prop of __getOwnPropSymbols$3(b)) {
      if (__propIsEnum$3.call(b, prop))
        __defNormalProp$3(a, prop, b[prop]);
    }
  return a;
};
const PollOption = withRCEHelpers((props) => {
  var _a, _b;
  const { layout, rce } = props;
  if (rce.isWebView) {
    switch ((_a = layout.poll) == null ? void 0 : _a.type) {
      case LAYOUTS.GRID:
        return /* @__PURE__ */ React.createElement(PollGridOptionWebview, __spreadValues$3({}, props));
      case LAYOUTS.LIST:
      default:
        return /* @__PURE__ */ React.createElement(PollListOptionWebview, __spreadValues$3({}, props));
    }
  }
  switch ((_b = layout.poll) == null ? void 0 : _b.type) {
    case LAYOUTS.GRID:
      return /* @__PURE__ */ React.createElement(PollGridOption, __spreadValues$3({}, props));
    case LAYOUTS.LIST:
    default:
      return /* @__PURE__ */ React.createElement(PollListOption, __spreadValues$3({}, props));
  }
});

var styles = {"fontElementMap":"_7i4Lu","container":"byhJx","fullscreen":"UesFG","background_overlay":"iLDtN","with_image":"b-D2s","options":"bTbQl","webview":"PjBLI","grid":"a4kBG","option":"OMthq","cta_button":"_6qn24","add_option":"F6Zfw","see_more":"R--oq","list":"rMhh-","column":"FI9q0","additional_note":"_8efza","spinner":"_3w0OA","spin":"TUUSY","shown":"_9b5Sl","error":"pqzFZ"};

const ROOT = "pollsViewer";

var __defProp$2 = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2 = Object.getOwnPropertySymbols;
var __hasOwnProp$2 = Object.prototype.hasOwnProperty;
var __propIsEnum$2 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2 = (obj, key, value) => key in obj ? __defProp$2(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2.call(b, prop))
      __defNormalProp$2(a, prop, b[prop]);
  if (__getOwnPropSymbols$2)
    for (var prop of __getOwnPropSymbols$2(b)) {
      if (__propIsEnum$2.call(b, prop))
        __defNormalProp$2(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
class PollComponent extends Component {
  constructor(props) {
    super(props);
    this.vote = async (optionId) => {
      this.setState({ error: null });
      try {
        await this.props.vote(optionId);
      } catch (error) {
        console.error("[rce-social-polls] vote: ", error.response);
        this.setState({ error: error.message });
        return Promise.reject(error);
      }
    };
    this.unvote = async (optionId) => {
      this.setState({ error: null });
      try {
        await this.props.unvote(optionId);
      } catch (error) {
        console.error("[rce-social-polls] unvote: ", error.response);
        this.setState({ error: error.message });
        return Promise.reject(error);
      }
    };
    this.toggleCollapse = () => this.setState({ collapsed: !this.state.collapsed });
    this.handleCTAFocus = (e) => {
      e.stopPropagation();
      this.props.rce.setInPluginEditingMode(true);
    };
    this.handleCTABlur = () => this.props.rce.setInPluginEditingMode(false);
    this.onResize = ({ bounds }) => this.setState({ bounds });
    this.state = {
      collapsed: this.isInitiallyCollapsed(),
      error: null,
      loading: false,
      bounds: null
    };
  }
  async componentDidMount() {
    const { poll } = this.props;
    if (poll.id) {
      this.fetchPoll();
    }
  }
  componentDidCatch(error) {
    this.setState({ error: error.message });
  }
  async fetchPoll() {
    const { t } = this.context;
    if (this.props.rce.isWebView || this.props.rce.preventInteraction) {
      return;
    }
    this.setState({
      loading: true,
      error: null
    });
    try {
      await this.props.fetchPoll();
    } catch (error) {
      console.error("[rce-social-polls] fetchPoll: ", error);
      this.setState({ error: t("Poll_Viewer_Toast_Error_ServerDown") });
    } finally {
      this.setState({ loading: false });
    }
  }
  isInitiallyCollapsed() {
    const { poll } = this.props;
    return poll.options.length > 4;
  }
  handleOptionUpdate(index) {
    return (option) => this.props.updatePollOption(index, option);
  }
  handleOptionRemove(index) {
    return () => this.props.removeOption(index);
  }
  getNotes() {
    var _a, _b;
    const { poll } = this.props;
    const { t } = this.context;
    return [
      {
        condition: (_a = poll.settings.permissions) == null ? void 0 : _a.allowMultipleVotes,
        label: t("Poll_Viewer_Multiselect_Footer")
      },
      {
        condition: ((_b = poll.settings.permissions) == null ? void 0 : _b.view) === VISIBILITY_OPTIONS.CREATOR && poll.creatorFlag,
        label: t("Poll_Viewer_Visibility_Owner_Footer")
      }
    ].filter((note) => !!note.condition);
  }
  showResults() {
    var _a;
    const { permissions } = this.props.poll.settings;
    switch (permissions == null ? void 0 : permissions.view) {
      case VISIBILITY_OPTIONS.EVERYONE:
        return true;
      case VISIBILITY_OPTIONS.VOTERS:
        return this.props.poll.creatorFlag || !!((_a = this.props.poll.ownVotes) == null ? void 0 : _a.length);
      case VISIBILITY_OPTIONS.CREATOR:
        return this.props.poll.creatorFlag;
      default:
        return false;
    }
  }
  hasImageBackground() {
    var _a, _b, _c, _d;
    return !!((_d = (_c = (_b = (_a = this.props.design.poll) == null ? void 0 : _a.background) == null ? void 0 : _b.image) == null ? void 0 : _c.src) == null ? void 0 : _d.url);
  }
  getOptionList() {
    const { poll, rce } = this.props;
    const { collapsed } = this.state;
    if (!rce.isViewMode || this.showEditControls()) {
      return poll.options;
    }
    let list;
    if (!this.showResults()) {
      list = poll.options;
    } else {
      list = Array.from(poll.options).sort((prev, option) => {
        if (!prev.rating) {
          return 1;
        }
        if (option.rating === prev.rating) {
          return 0;
        }
        if (option.rating > prev.rating) {
          return 1;
        }
        return -1;
      });
    }
    return collapsed ? list.slice(0, 4) : list;
  }
  showEditControls() {
    const { rce } = this.props;
    return !rce.isViewMode && !rce.isPreview;
  }
  render() {
    var _a, _b;
    const { poll, rce, getVoters, addOption, design, layout, siteMembers } = this.props;
    const { collapsed, loading, bounds } = this.state;
    const { isMobile, t } = this.context;
    const style = __spreadProps(__spreadValues$2({}, design.poll), {
      background: toBackgroundString(
        (_a = design.poll) == null ? void 0 : _a.background,
        (_b = design.poll) == null ? void 0 : _b.background.type,
        bounds == null ? void 0 : bounds.width,
        bounds == null ? void 0 : bounds.height
      )
    });
    return /* @__PURE__ */ React.createElement(Measure, { bounds: true, onResize: this.onResize }, ({ measureRef }) => {
      var _a2, _b2, _c, _d, _e, _f;
      return /* @__PURE__ */ React.createElement(
        "div",
        {
          className: cls(styles.container, {
            [styles.isMobile]: isMobile,
            [styles.webview]: rce.isWebView,
            [styles.fullscreen]: rce.isPreview,
            [styles.dark]: this.hasImageBackground()
          }),
          style,
          dir: (_a2 = layout.poll) == null ? void 0 : _a2.direction,
          ref: measureRef,
          "data-hook": ROOT
        },
        /* @__PURE__ */ React.createElement(
          "div",
          {
            className: cls(styles.background_overlay, {
              [styles.with_image]: this.hasImageBackground()
            })
          }
        ),
        /* @__PURE__ */ React.createElement(PollHeader, null),
        /* @__PURE__ */ React.createElement(
          "ul",
          {
            className: cls(styles.options, {
              [styles.list]: ((_b2 = layout.poll) == null ? void 0 : _b2.type) === LAYOUTS.LIST,
              [styles.grid]: ((_c = layout.poll) == null ? void 0 : _c.type) === LAYOUTS.GRID,
              [styles.with_image]: (_d = layout.options) == null ? void 0 : _d.enableImage
            })
          },
          /* @__PURE__ */ React.createElement(
            FlipMove,
            {
              typeName: null,
              disableAllAnimations: this.showEditControls(),
              enterAnimation: "none",
              leaveAnimation: "none",
              verticalAlignment: "bottom"
            },
            this.getOptionList().map((option, i) => /* @__PURE__ */ React.createElement("li", { className: styles.option, key: option.id || i }, /* @__PURE__ */ React.createElement(
              PollOption,
              {
                option,
                update: this.handleOptionUpdate(i),
                remove: this.handleOptionRemove(i),
                removeEnabled: this.showEditControls() && poll.options.length > 1,
                vote: this.vote,
                unvote: this.unvote,
                poll,
                showResults: this.showResults(),
                dark: this.hasImageBackground()
              }
            ), /* @__PURE__ */ React.createElement(
              VotedUsers,
              {
                option,
                siteMembers,
                showResults: this.showResults(),
                showVoters: poll.settings.showVoters,
                showVotes: poll.settings.showVotesCount,
                fetchVoters: (params) => getVoters(option.id, params)
              }
            ))),
            this.showEditControls() && /* @__PURE__ */ React.createElement("li", { className: styles.column }, /* @__PURE__ */ React.createElement(
              "button",
              {
                onClick: addOption,
                onFocus: this.handleCTAFocus,
                onBlur: this.handleCTABlur,
                className: styles.add_option,
                style: design.options,
                type: "button"
              },
              ((_e = layout.poll) == null ? void 0 : _e.type) === LAYOUTS.GRID && ((_f = layout.options) == null ? void 0 : _f.enableImage) ? /* @__PURE__ */ React.createElement(AddIcon, null) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(AddIcon, { width: 24, height: 24 }), "\xA0", t("Poll_Editor_Answer_AddAnswer"))
            ))
          )
        ),
        poll.options.length > 4 && !this.showEditControls() && /* @__PURE__ */ React.createElement(
          "button",
          {
            onClick: this.toggleCollapse,
            className: styles.see_more,
            style: design.options,
            type: "button"
          },
          collapsed ? this.showResults() ? t("Poll_Viewer_ShowAllResults_CTA") : t("Poll_Viewer_ShowAllOptions_CTA") : t("Poll_Viewer_ShowLess_CTA")
        ),
        this.getNotes().map((note, i) => /* @__PURE__ */ React.createElement("p", { className: styles.additional_note, key: i }, note.label)),
        /* @__PURE__ */ React.createElement(
          LoaderIcon,
          {
            className: cls(styles.spinner, {
              [styles.shown]: loading
            }),
            width: 24,
            height: 24
          }
        )
      );
    });
  }
}
PollComponent.propTypes = __spreadValues$2(__spreadValues$2({}, PollContextPropTypes), RCEHelpersPropTypes);
PollComponent.contextType = RicosContext;
const Poll$1 = withRCEHelpers(withPoll(PollComponent));

var __defProp$1 = Object.defineProperty;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1.call(b, prop))
      __defNormalProp$1(a, prop, b[prop]);
  if (__getOwnPropSymbols$1)
    for (var prop of __getOwnPropSymbols$1(b)) {
      if (__propIsEnum$1.call(b, prop))
        __defNormalProp$1(a, prop, b[prop]);
    }
  return a;
};
const Polls = (props) => {
  const { theme, t, isMobile } = useContext(RicosContext);
  const setPoll = (poll) => {
    const { updateAttributes } = props;
    updateAttributes == null ? void 0 : updateAttributes({ poll });
  };
  const { componentData, helpers, editorEvents, selected, isViewMode = false, settings } = props;
  return /* @__PURE__ */ React.createElement(
    RCEHelpersContext.Provider,
    {
      value: __spreadValues$1({
        isViewMode: isViewMode ? isViewMode : settings.isWebView || typeof selected === "boolean" ? !selected : true,
        setInPluginEditingMode: () => {
        },
        layout: componentData.layout,
        design: componentData.design,
        preventVoting: !isViewMode,
        isPreview: isMobile,
        helpers,
        theme,
        t,
        isMobile
      }, settings)
    },
    /* @__PURE__ */ React.createElement(
      PollContextProvider,
      {
        editorEvents,
        settings,
        poll: componentData.poll,
        setPoll,
        t
      },
      /* @__PURE__ */ React.createElement(Poll$1, null)
    )
  );
};
var PollViewer = withEditorEvents(Polls);

const Poll = ({ node, nodeIndex, NodeViewContainer }) => {
  const { config } = useContext(RicosViewerContext);
  return /* @__PURE__ */ React.createElement(NodeViewContainer, { node, nodeIndex }, /* @__PURE__ */ React.createElement(
    PollViewer,
    {
      componentData: node.pollData,
      settings: config[POLL_TYPE],
      isViewMode: true
    }
  ));
};

const nodeViewRenderers = {
  [Node_Type.POLL]: Poll
};

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const pluginPoll = (config) => {
  return {
    config: __spreadValues(__spreadValues({}, DEFAULT_RICOS_COMPONENT_DATA.containerData), config),
    type: POLL_TYPE,
    nodeViewRenderers
  };
};

export { POLL_TYPE, pluginPoll };
//# sourceMappingURL=viewer.js.map

import 'wix-rich-content-plugin-social-polls/dist/es/styles.viewer.min.global.css'